export default __webpack_public_path__ + "static/media/wellcome-bg.9a006a17.svg";